import React, { useState, useEffect, useRef } from "react";
import { ImCancelCircle } from "react-icons/im";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import axios from "axios";
import ContactForm from "./ContactForm";
import Pagination from "../component/paginations/pagination";
import { data } from "autoprefixer";
import ContactApi from "../api/ContactApi";

const ContactList = ({ refresh }) => {
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalContact, setTotalContact] = useState(0);
  const [showDetails, setShowDetails] = useState(false);
  const taskDetailsRef = useRef(null);
  const [editContactId, setEditContactId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    getContact();
  }, [refresh, currentPage, postsPerPage, searchQuery]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (taskDetailsRef.current && !taskDetailsRef.current.contains(event.target)) {
        setShowDetails(false);
      }
    };

    if (showDetails) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDetails]);

  const getContact = async () => {
    try {
      setLoading(true);

      const response = await axios.get("/wp-json/devs-accounting/v1/contacts/", {
        params: {
          page: currentPage,
          per_page: postsPerPage,
          search: searchQuery,
        },
      });
      const res = response.data;
      // console.log(res);

      setState(res.data);
      setTotalContact(res.total_contact);
      
    } catch (error) {
      console.error("Error fetching contacts:", error);
      setState([]);
      setTotalContact(data);
    } finally {
      setLoading(false);
    }
  };

  const deleteContact = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this Contact?");
    if (confirmDelete) {
        try {
            await ContactApi.delete(id);
            getContact();
        } catch (error) {
            console.error("Error deleting Contact:", error.message);
        }
    }
};

  const toggleDetails = (contactId = null) => {
    setShowDetails(!showDetails);
    setEditContactId(contactId);
  };

  const handlePostsPerPageChange = (e) => {
    const newPostsPerPage = parseInt(e.target.value);
    setPostsPerPage(newPostsPerPage);
    setCurrentPage(1); // Reset to the first page when changing posts per page
  };

  // console.log(totalContact)
  // console.log(state)

  return (
    <div>
      <div className="mx-auto">
        <div className="flex justify-between items-center bg-white px-6 py-4 border-b">
          <div className="text-lg text-gray-500">
            <h1>All Contacts</h1>
          </div>
          <div className="flex gap-x-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Search items..."
                className="appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded py-2.5 px-4 ml-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <div className="absolute right-2 top-[25%]">
              <FiSearch size={20} />
              </div>
            </div>
            <div>
              <button
                onClick={() => toggleDetails()}
                className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
              >
                Add
              </button>
            </div>
          </div>
        </div>

        <div className="flex flex-col">
          <div className="overflow-x-auto shadow-md sm:rounded-lg">
            <div className="inline-block min-w-full align-middle">
              <div className="overflow-hidden">
                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                  <thead className="bg-gray-100 dark:bg-gray-700">
                    <tr>
                      <th scope="col" className="p-4">
                        <div className="flex items-center">
                          <input
                            id="checkbox-all"
                            type="checkbox"
                            className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <label htmlFor="checkbox-all" className="sr-only">
                            checkbox
                          </label>
                        </div>
                      </th>
                      <th className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Name
                      </th>
                      <th className="py-3 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Type
                      </th>
                      <th className="py-3 px-[100px] text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Email
                      </th>
                      <th className="py-3 px-[60px] text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Mobile
                      </th>
                      <th className="p-4">
                        <span className="sr-only">Edit</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                    {state.map((contact, index) => (
                      <tr className="hover:bg-gray-100 dark:hover:bg-gray-700" key={index}>
                        <td className="p-4 w-4">
                          <div className="flex items-center">
                            <input
                              id={`checkbox-${index}`}
                              type="checkbox"
                              className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            />
                            <label htmlFor={`checkbox-${index}`} className="sr-only">
                              checkbox
                            </label>
                          </div>
                        </td>
                        <td className="px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          {contact.name}
                        </td>
                        <td className="px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          {contact.type}
                        </td>
                        <td className="px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          {contact.email}
                        </td>
                        <td className="px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                          {contact.phone}
                        </td>
                        <td className="p-3 text-sm font-medium float-right whitespace-nowrap flex my-auto">
                          <a
                            onClick={() => toggleDetails(contact.id)}
                            href="#"
                            title="Edit"
                            className="text-blue-600 dark:text-blue-500 hover:underline text-2xl"
                          >
                            <FaEdit />
                          </a>
                          <button
                            title="Delete"
                            onClick={() => deleteContact(contact.id)}
                            className="ml-2 text-blue-600 dark:text-blue-500 hover:underline text-2xl"
                          >
                            <MdDelete />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {state.length > 0 && (
            <div className="flex justify-end items-center mt-4 gap-4">
              <div className="flex items-center border border-gray-300 rounded-lg px-4 py-1 bg-white shadow-sm">
                <p className="mr-2 text-gray-700">Per Page</p>
                <select
                  className="appearance-none pl-2 pr-5 py-1 text-gray-700 focus:outline-none focus:border-indigo-500"
                  value={postsPerPage}
                  onChange={handlePostsPerPageChange}
                >
                  {[10, 20, 30, 50].map((value) => (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  ))}
                </select>
              </div>

              <Pagination
                totalPosts={totalContact}
                postsPerPage={postsPerPage}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </div>
          )}
          {showDetails && (
            <div
              className={`fixed z-10 top-8 md:top-8 right-0 w-full h-full shadow-2xl max-w-[50rem] bg-white transition-transform duration-300 overflow-y-auto ${
                showDetails ? "transform translate-x-0" : "transform translate-x-full"
              }`}
              ref={taskDetailsRef}
            >
              <div className="flex justify-between p-3">
                <a
                  className="mt-2 !ml-2 text-2xl text-gray-400 cursor-pointer"
                  onClick={() => toggleDetails()}
                >
                  <ImCancelCircle />
                </a>
              </div>
              <div>
                <ContactForm contactId={editContactId} onSubmits={getContact} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactList;
